import { getNonBootUserConfigurationSync } from "../getNonBootUserConfiguration";
import type { MailboxInfo } from "owa-client-types";

export default function isCompliantMeetingEnabled(mailboxInfo: MailboxInfo): boolean {
    const { CompliantMeetingEnabled = false } = getNonBootUserConfigurationSync(mailboxInfo) || {};
    return CompliantMeetingEnabled;
}
